// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Record from "../Record/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Totality from "../Restaumatic.Form.Totality/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FormField from "../Specular.FormField/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var identity = /* #__PURE__ */ Control_Category.identity(Record_Builder.categoryBuilder);
var map1 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var liftFinal = /* #__PURE__ */ Restaumatic_Form_DynamicResult.liftFinal();
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var apply = /* #__PURE__ */ Control_Apply.apply(Restaumatic_Form_DynamicResult.applyDynamicResult);
var composeFlipped = /* #__PURE__ */ Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder);
var insert = /* #__PURE__ */ Record_Builder.insert()();
var relax = /* #__PURE__ */ Restaumatic_Form_DynamicResult.relax();
var Strict = /* #__PURE__ */ (function () {
    function Strict() {

    };
    Strict.value = new Strict();
    return Strict;
})();
var Lax = /* #__PURE__ */ (function () {
    function Lax() {

    };
    Lax.value = new Lax();
    return Lax;
})();
var queryUnitRecordTotal = function (dictTypeEquals) {
    return {
        queryImpl: function (v) {
            return function (v1) {
                return pure(Data_Unit.unit);
            };
        }
    };
};
var queryRefTotal = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        queryImpl: function (v) {
            var $88 = map(to);
            return function ($89) {
                return Restaumatic_Form_DynamicResult.liftDynamic($88(Specular_Ref.value($89)));
            };
        }
    };
};
var queryRecordNilTotal = {
    queryRecordImpl: function (v) {
        return function (v1) {
            return function (v2) {
                return pure(identity);
            };
        };
    }
};
var queryFinalPartial = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        queryImpl: function (v) {
            var $90 = map1(to);
            return function ($91) {
                return $90(liftFinal($91));
            };
        }
    };
};
var queryDynamicTotal = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        queryImpl: function (v) {
            var $92 = map(to);
            return function ($93) {
                return Restaumatic_Form_DynamicResult.liftDynamic($92($93));
            };
        }
    };
};
var eqStrictness = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Strict && y instanceof Strict) {
                return true;
            };
            if (x instanceof Lax && y instanceof Lax) {
                return true;
            };
            return false;
        };
    }
};
var queryRecordImpl = function (dict) {
    return dict.queryRecordImpl;
};
var queryRecord = function (dictAsRecord) {
    var fromRecord = Restaumatic_Form_Internal.fromRecord(dictAsRecord);
    return function () {
        return function (dictQueryRecord) {
            var queryRecordImpl1 = queryRecordImpl(dictQueryRecord);
            return {
                queryImpl: function (s) {
                    return function (f) {
                        return map1((function () {
                            var $94 = Data_Function.flip(Record_Builder.build)({});
                            return function ($95) {
                                return fromRecord($94($95));
                            };
                        })())(queryRecordImpl1(s)(Type_Proxy["Proxy"].value)(f));
                    };
                }
            };
        };
    };
};
var queryImpl = function (dict) {
    return dict.queryImpl;
};
var queryWith = function (dictQuery) {
    var queryImpl1 = queryImpl(dictQuery);
    return function (v) {
        if (v instanceof Lax) {
            var $96 = queryImpl1(Lax.value);
            return function ($97) {
                return Restaumatic_Form_DynamicResult.toLax($96($97));
            };
        };
        if (v instanceof Strict) {
            var $98 = queryImpl1(Strict.value);
            return function ($99) {
                return Restaumatic_Form_DynamicResult.toStrict($98($99));
            };
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Query (line 93, column 1 - line 93, column 70): " + [ v.constructor.name ]);
    };
};
var queryLax = function (dictQuery) {
    return queryWith(dictQuery)(Lax.value);
};
var queryLaxWithDefault = function (dictQuery) {
    var queryWith1 = queryWith(dictQuery);
    return function (def) {
        var $100 = Restaumatic_Form_Internal.unFinalWithDefault(def);
        var $101 = queryWith1(Lax.value);
        return function ($102) {
            return $100($101($102));
        };
    };
};
var queryDelayed = function (dictQuery) {
    var queryImpl1 = queryImpl(dictQuery);
    return {
        queryImpl: function (s) {
            return function (v) {
                return Restaumatic_Form_DynamicResult.wrap(bind(v)(function (field) {
                    return Restaumatic_Form_DynamicResult.unwrap(queryImpl1(s)(field));
                }));
            };
        }
    };
};
var queryFormFieldPartial = function (dictTypeEquals) {
    var queryImpl1 = queryImpl(queryFinalPartial(dictTypeEquals));
    return {
        queryImpl: function (s) {
            var $103 = queryImpl1(s);
            return function ($104) {
                return $103(Specular_FormField.finalValueNoErr($104));
            };
        }
    };
};
var queryRecordCons = function (dictIsSymbol) {
    var insert1 = insert(dictIsSymbol);
    var get = Record.get(dictIsSymbol)();
    return function (dictQueryRecord) {
        var queryRecordImpl1 = queryRecordImpl(dictQueryRecord);
        return function (dictQuery) {
            var queryImpl1 = queryImpl(dictQuery);
            return function () {
                return function () {
                    return function () {
                        return function () {
                            return function () {
                                return {
                                    queryRecordImpl: function (s) {
                                        return function (v) {
                                            return function (f) {
                                                return apply(map1(function (v1) {
                                                    return function (v2) {
                                                        return composeFlipped(v2)(insert1(Type_Proxy["Proxy"].value)(v1));
                                                    };
                                                })(relax(queryImpl1(s)(get(Type_Proxy["Proxy"].value)(f)))))(relax(queryRecordImpl1(s)(Type_Proxy["Proxy"].value)(f)));
                                            };
                                        };
                                    }
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var queryT2T2 = function (dictQuery) {
    var queryImpl1 = queryImpl(dictQuery);
    return function (dictQuery1) {
        var queryImpl2 = queryImpl(dictQuery1);
        return function () {
            return {
                queryImpl: function (s) {
                    return function (v) {
                        return apply(map1(Data_Tuple_T2.T2.create)(relax(queryImpl1(s)(v.value0))))(relax(queryImpl2(s)(v.value1)));
                    };
                }
            };
        };
    };
};
var query = function (dictQuery) {
    return queryWith(dictQuery)(Strict.value);
};
export {
    Strict,
    Lax,
    query,
    queryImpl,
    queryLax,
    queryLaxWithDefault,
    queryRecordImpl,
    queryWith,
    eqStrictness,
    queryRefTotal,
    queryDynamicTotal,
    queryFinalPartial,
    queryFormFieldPartial,
    queryDelayed,
    queryT2T2,
    queryUnitRecordTotal,
    queryRecord,
    queryRecordNilTotal,
    queryRecordCons
};
export {
    DynamicResult,
    andThen,
    annotated,
    errors,
    liftDynamic,
    liftFinal,
    liftResult,
    over,
    relax,
    toLax,
    toStrict,
    toTotal,
    unsafeStrenghten,
    unwrap,
    wrap
} from "../Restaumatic.Form.DynamicResult/index.js";
export {
    ProofIsPartial,
    absurd,
    isPartial,
    isTotal
} from "../Restaumatic.Form.Totality/index.js";
